import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../store';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../util/apiClient';
import CommonListe from '../../Common/CommonListe';
import { setObjGroupeFonctionnalite } from '../GroupeFonctionnalite/groupeFonctionnaliteSlice';
import { deleteFonctionnalite, IFonctionnalite, setDescriptionEdit, setFonctionalitesByGroupeFonctionalite, setObjFonctionnalite, setOpenDialogFonctionnalite, setValueEdit } from './fonctionnaliteSlice';



const ListeFonctionalite = () => {


    //redux
    const dispatch = useDispatch()
    const { objModule } = useSelector((state: IReduxState) => state.module);
    const { objGroupeFonctionnalite } = useSelector((state: IReduxState) => state.groupeFonctionnalite);
    const { fonctionnalites, fonctionnalitesByGroupeFonctionalite } = useSelector((state: IReduxState) => state.fonctionnalite);



    const deleteItem = async (item: IFonctionnalite) => {
        try {
            const apiPayload = { idFonctionnalite: item.idFonctionnalite }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/route", apiPayload)
            if (res.status === 1) {
                dispatch(deleteFonctionnalite(res.data))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };



    const handleEditDialogOpen = (item: IFonctionnalite) => {
        dispatch(setOpenDialogFonctionnalite(true))
        dispatch(setObjFonctionnalite(item))
        dispatch(setValueEdit(item.libelleFonctionnalite))
        dispatch(setDescriptionEdit(item.descriptionFonctionnalite))
    }

    const getFonctionalitesByGroupeFonctionalite = () => {
        dispatch(setFonctionalitesByGroupeFonctionalite(fonctionnalites.filter((fonctionnalite: IFonctionnalite) => fonctionnalite.idGroupeFonctionnalite === objGroupeFonctionnalite.idGroupeFonctionnalite)))
    }

    useEffect(() => {
        getFonctionalitesByGroupeFonctionalite()
    }, [objGroupeFonctionnalite, fonctionnalites]);



    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <CommonListe
                data={fonctionnalitesByGroupeFonctionalite}
                deleteItem={deleteItem}
                setItem={setObjFonctionnalite}
                handleEditDialogOpen={handleEditDialogOpen}
            />
        </Box>
    );
}

export default ListeFonctionalite;
